import api from './api';

const cartService = {
  get: () => api.get('/cart'),
  add: (productId, quantity = 1, variantId = null) => api.post('/cart/add', { productId, quantity, variantId }),
  updateItem: (productId, quantity) => api.put(`/cart/item/${productId}`, { quantity }),
  removeItem: (productId) => api.delete(`/cart/item/${productId}`),
  clear: () => api.delete('/cart'),
  saveForLater: (productId) => api.post(`/cart/save-for-later/${productId}`),
  moveToCart: (productId) => api.post(`/cart/move-to-cart/${productId}`),
  removeSaved: (productId) => api.delete(`/cart/saved/${productId}`),
  mergeGuestCart: () => api.post('/cart/merge'),
};

export default cartService;
